module.exports = __webpack_public_path__ + "bin/1d220e01f76626d45098138dde0f9cee.svg";